<tt-page *ngIf="!!setting">
    <ng-container *ngIf="tabletSize.matches; else mobileView">
        <tt-card *ngIf="itemState === 'p2subscriptionedit'" class="col-xs-12 col-md-9 p-5" ttHeading="h_subscription"></tt-card>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-6 p-5">
                <tt-input ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-button ttText="new_p2_subscription" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createSubscription($event)"></tt-button>
            </tt-card>
        </div>

        <ng-container *ngIf="itemState !== 'p2subscriptionedit'; else inlineEditor">
            <tt-list [ttData]="subscriptions" [ttFilter]="setting.searchtext" (ttClick)="openSubscription($event.item, $event.event)"></tt-list>
        </ng-container>

        <ng-template #inlineEditor>
            <tt-divider ttRememberId="p2subscription_dividers">
                <tt-divider-columns>
                    <tt-divider-pane ttSize="50">
                        <tt-list class="col-xs-12 p-5" [ttData]="subscriptions" [ttFilter]="setting.searchtext" (ttClick)="openSubscription($event.item, $event.event)"></tt-list>
                    </tt-divider-pane>

                    <tt-divider-pane ttSize="50">
                        <tt-p2-subscription-edit *ngIf="selectedSubscriptionKeyno !== ''" class="col-xs-12 p-5" [p2SubscriptionKeyno]="selectedSubscriptionKeyno" [inline]="true" (onSave)="updateList()"></tt-p2-subscription-edit>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider>
        </ng-template>
    </ng-container>

    <ng-template #mobileView>
        <tt-card class="col-xs-12 sp-0">
            <tt-input ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
            <tt-button-goto
                ttText="new_p2_subscription"
                ttGoto="p2subscriptionedit"
                [ttGotoParms]="{ p2_subscription_keyno: '0' }"
                ttTextAlign="left"
                ttIcon="fas fa-plus">
            </tt-button-goto>
        </tt-card>

        <tt-list [ttData]="subscriptions" [ttFilter]="setting.searchtext" (ttClick)="openSubscription($event.item, $event.event)"></tt-list>
    </ng-template>
</tt-page>
